import { render, staticRenderFns } from "./DealDeliverySlip.vue?vue&type=template&id=6bedc138&"
import script from "./DealDeliverySlip.vue?vue&type=script&lang=ts&"
export * from "./DealDeliverySlip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports